import { PsvMonitoringProgramStatus } from "@api/shared-runtime/psv-monitoring";
import { MonitoringBadgeKind } from "./monitoring-constants";
import { MonitoringStatusBadge } from "./monitoring-status-badge";

const POOL_CELL_PRESENTATION = {
  [PsvMonitoringProgramStatus.Active]: {
    kind: MonitoringBadgeKind.Monitored,
    label: "On",
  },
  [PsvMonitoringProgramStatus.Paused]: {
    kind: MonitoringBadgeKind.Paused,
    label: "Paused",
  },
  [PsvMonitoringProgramStatus.Archived]: {
    kind: MonitoringBadgeKind.NotMonitored,
    label: "Off",
  },
} as const;

const OFF_PRESENTATION =
  POOL_CELL_PRESENTATION[PsvMonitoringProgramStatus.Archived];

/** Pools list "Monitoring" cell. A pool absent from the status list is off. */
export function PoolMonitoringCell({
  status,
}: {
  status: PsvMonitoringProgramStatus | undefined;
}) {
  const { kind, label } = status
    ? POOL_CELL_PRESENTATION[status]
    : OFF_PRESENTATION;
  return <MonitoringStatusBadge kind={kind} label={label} />;
}
